"use client";

import { MissionSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedMissionSection from "../Components/GeneratedMissionSection";

const Mission: FC<MissionSectionProps> = (props) => {
  return <GeneratedMissionSection {...props} />;
};

export default Mission;
